/* eslint "react/no-array-index-key": "off" */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import React from "react";
import { twMerge } from "@stereoagency/tailwind-config";
import { useAccentColors } from "../../hooks";
export default function DotPagination(param) {
    var active = param.active, count = param.count, onSelect = param.onSelect, style = param.style, _param_accentColor = param.accentColor, accentColor = _param_accentColor === void 0 ? "--colors-blue-500" : _param_accentColor, className = param.className;
    var accentStyle = useAccentColors([
        "colors-dot-pagination-accent",
        accentColor
    ]);
    return /*#__PURE__*/ React.createElement("div", {
        className: twMerge("flex justify-center items-center", className),
        style: _object_spread({}, style, accentStyle)
    }, new Array(count).fill(null).map(function(_, index) {
        return /*#__PURE__*/ React.createElement("button", {
            key: "bullet-".concat(index),
            type: "button",
            "aria-label": String(index + 1),
            className: twMerge("mx-2 w-[0.625rem] h-[0.625rem] rounded-full bg-neutral-900/30 transition-all", active === index && "w-[2.375rem] bg-[var(--colors-dot-pagination-accent)]"),
            onClick: function() {
                return onSelect === null || onSelect === void 0 ? void 0 : onSelect(index);
            }
        });
    }));
}

//# sourceMappingURL=DotPagination.js.map